<mat-form-field appearance="fill">
    <mat-label>Order Type</mat-label>
    <mat-select [formControl]="selectorFormControl" #selector>
        <mat-option *ngFor="let soType of soTypes" [value]="soType.id">{{soType.id}} - {{soType.descr}}
        </mat-option>
    </mat-select>
</mat-form-field>